import { render } from "./SidebarContent.vue?vue&type=template&id=b3906cb8&scoped=true"
import script from "./SidebarContent.vue?vue&type=script&lang=js"
export * from "./SidebarContent.vue?vue&type=script&lang=js"

import "./SidebarContent.vue?vue&type=style&index=0&id=b3906cb8&scoped=true&lang=css"
import "./SidebarContent.vue?vue&type=style&index=1&id=b3906cb8&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3906cb8"]])

export default __exports__